module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm09_plates"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v("PLATES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LATES")])]), _vm._v(" "), _c('p', {
    staticClass: "rightr"
  }, [_c('em', [_vm._v("following page "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#page_364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("364")])])]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "numberlistn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carved stone heads from Texas")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "numberlistn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tonkawas: Grant Richards, Winnie Richards, Sherman Niles, and William Stevens")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "numberlistn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A group of Tonkawas")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "numberlistn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comanche warriors")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "numberlistn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Quahadi Comanche camp")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "numberlistn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Comanche woman; Tabatoso, a Comanche")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "numberlistn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Kiowa and his daughters")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "numberlistn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kiowas: wife of Big Tree; daughter of Kicking Bird; Kiowa scout")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "numberlistn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wichita girl, late nineteenth century")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "numberlistn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tawakoni Jim, principal chief of the confederated Wichita, Waco, and Tawakoni tribes; two Wichita women and a baby")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "numberlistn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sam Houston, a Caddo")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "numberlistn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caddoes: Nah-ah-sa-nah (known also as Warloupe); Minnie Parton and Charlie Parton")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "numberlistn"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indentm1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_ps#plat12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sole Comanche survivor of a twelve-man war party raid against the Texas frontier; a Comanche captive")]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f0932f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm09_plates.vue
// module id = 84
// module chunks = 0